/**
 * 图片精灵非动态图片 支持层级
 */
import fvSubassembly from "../fvSubassembly"
export default class fvPictureObj extends fvSubassembly {
    constructor(sContent, parent, system, callback) {
        super(sContent, parent, system);
        if(this.Border == undefined){
            this.Border = 0;
        }
       //是否启用边框
       this.isBorder = this.Border || 0;
       //线宽
       this.borderLineWidth = this.LineWidth || 1;

       //旋转角度
       this.pictureRotate = this.Rotate || 0;
       //判断旋转一次
       this.isRotate = this.Rotate || false;
        //透明度
        this.hyalineValue = 1;
        //是否启用透明背景色
        this.isHyaline = false;
        //透明背景色
        this.HyalineColor = '';
        this.isEnable=true;
        //通过全局缓存中加载图片，加载完毕后动态生成ondraw方法，在这之前，走父类
        this.create();
        var fileName = this.fvScript.system.$.getResource(this.fileName);
        if (fileName) {
            var arr = this.src.split("/");
            arr[arr.length - 1] = fileName
            this.src = arr.join("/");
        }
        this.fvScript.system.$.getImgCache(this.src).then((img) => {
            this.img = img;
            callback(this);
        }, ((img) => {
            this.img = img;
            callback(this);
        }));
        // 创建图元
        //创建图片
        this.imgG=document.createElementNS('http://www.w3.org/2000/svg', 'g');
        this.imgBorderDom = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
        this.imgDom = document.createElementNS('http://www.w3.org/2000/svg', 'image');
        this.imgMaskDom = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
        system.appendChild(this.imgG)
        this.imgG.appendChild(this.imgBorderDom)
        this.imgG.appendChild(this.imgDom);
        if(sContent.animation!==null){
            this.createSucss(this.imgG, sContent);
        }
        this.pictureFun();
        this.system=system;
        this.createStyle();
        this.stoke="rgba(0,0,0,0)";
    }
    async updataPic() {
        var fileName =await this._this.$.getResource(this.fileName);
        if (fileName) {
            var arr = this.src.split("/");
            arr[arr.length - 1] = fileName
            this.src = arr.join("/");
        }
        await this._this.$.getImgCache(this.src).then((img) => {
            this.img = img;
        }, ((img) => {
            this.img = img;
        }));
        this.imgDom.href.baseVal=this.img.src;
    }
    createBorder(){
        if(this.isBorder != 0){
            this.imgBorderDom.setAttribute('x', this.cx - this.parent.parentX + (this.borderLineWidth/2));
            this.imgBorderDom.setAttribute('y', this.cy - this.parent.parentY + (this.borderLineWidth/2));
            this.imgBorderDom.style.width=this.width - this.borderLineWidth + "px";
            this.imgBorderDom.style.height = this.height - this.borderLineWidth + "px";
        }else{
            this.imgBorderDom.setAttribute('x', this.cx - this.parent.parentX);
            this.imgBorderDom.setAttribute('y', this.cy - this.parent.parentY);
            this.imgBorderDom.style.width=this.width + "px";
            this.imgBorderDom.style.height = this.height + "px"; 
        }
        
        //判断是否加边框
        if (this.isBorder != 0) {
            this.setBorder();
        }else{
            this.imgBorderDom.style.stroke=this.stoke;
            this.imgBorderDom.style.strokeWidth=0;
            this.imgBorderDom.style.fill="rgba(0,0,0,0)";
        }
        //判断是否设置透明背景色
        if (this.isHyaline) {
            this.imgBorderDom.style.fill = this.HyalineColor;
            this.imgBorderDom.style.fillOpacity = this.hyalineValue/255;
        }
        //判断是否旋转
        if (this.isRotate) {
            //计算旋转中心点
            var px = parseFloat(this.cx);
            var py = parseFloat(this.cy);

            var cx = parseFloat(px + (this.width / 2));
            var cy = parseFloat(py + (this.height / 2));
            //旋转// 旋转度数 * Math.PI/180
            this.imgDom.setAttribute("transform",`translate(${cx},${cy})rotate(${this.pictureRotate})translate(${-cx},${-cy})`)
            this.imgBorderDom.setAttribute("transform",`translate(${cx},${cy})rotate(${this.pictureRotate})translate(${-cx},${-cy})`)

        }
    }
    createStyle() {
        this.updataPic();
        this.createBorder();
        if(this.isBorder != 0){
            this.imgDom.setAttribute('x', this.cx - this.parent.parentX+(this.borderLineWidth));
            this.imgDom.setAttribute('y', this.cy - this.parent.parentY+(this.borderLineWidth));
            this.imgDom.style.width = this.width -(this.borderLineWidth*2)+ "px";
            this.imgDom.style.height = this.height -(this.borderLineWidth*2) + "px";
        }else{
            this.imgDom.setAttribute('x', this.cx - this.parent.parentX);
            this.imgDom.setAttribute('y', this.cy - this.parent.parentY);
            this.imgDom.style.width = this.width+ "px";
            this.imgDom.style.height = this.height + "px";
        }
        this.imgDom.setAttribute("preserveAspectRatio","none meet");
    }
    onDraw() {
        this.executePreAnimation(this.imgG);
        this.imgG.style.transform = `translate(${this.translateX + 'px'}, ${this.translateY + 'px'}) rotate(${this.rotating + 'deg'}`;
        this.imgG.style.transformOrigin = `${this.originPinitX + "px"}  ${this.originPinitY + "px"}`;
        
    }
    //设置边框
    setBorder() {
        this.imgBorderDom.style.strokeWidth=this.borderLineWidth;
        this.imgBorderDom.style.stroke="rgba(0,0,0,1)";
    }
    /*16进制颜色转为RGBA格式*/
    hexToRgba(hex, opacity) {
        return "rgba(" + parseInt("0x" + hex.slice(1, 3)) + "," + parseInt("0x" + hex.slice(3, 5)) + "," + parseInt("0x" + hex.slice(5, 7)) + "," + opacity + ")";
    }
     /*
        参数：isShow 显示隐藏
        作用：设置组件整体显隐
    */
    Show(isShow){
        if(isShow==0){
            this.imgG.style.display="none"
        }else{
            this.imgG.style.display="block"
        }
    }
    /*
        参数：isEnable 是否可用
        作用：设置组件是否可用
    */
    Enable(isEnable){
        if(isEnable==0){
            this.isEnable=true;
            this.system.appendChild(this.imgMaskDom);
            this.imgMaskDom.setAttribute('x', this.cx - this.parent.parentX + (this.borderLineWidth/2));
            this.imgMaskDom.setAttribute('y', this.cy - this.parent.parentY + (this.borderLineWidth/2));
            this.imgMaskDom.style.width=this.width - this.borderLineWidth + "px";
            this.imgMaskDom.style.height = this.height - this.borderLineWidth + "px";
            this.imgMaskDom.style.fill="rgba(204, 191, 191,.5)";
            if(this.imgDom.getAttribute("transform")!==null){
                this.imgMaskDom.setAttribute("transform",this.imgDom.getAttribute("transform"));
            }
            this.imgMaskDom.style.display="block";
        }else{
            this.imgMaskDom.style.display="none";
        }
    }
    pictureFun() {
        //监听边框宽度设置
        Object.defineProperty(this, "LineWidth", {
            set: function (value) {
                if(!this.isEnable){
                    this.borderLineWidth = value;
                    this.createBorder();
                    this.createStyle();
                }
            }
        })
        //设置旋转
        Object.defineProperty(this, "Rotate", {
            set: function (value) {
                if(!this.isEnable){
                    this.isRotate = true;
                    this.pictureRotate = value;
                    this.createBorder();
                    if(this.isEnable){
                        this.imgMaskDom.setAttribute("transform",this.imgDom.getAttribute("transform"));
                    }
                }
            },
            get: function () {
                return this.pictureRotate;
            }
        })
        Object.defineProperty(this, "Border", {
            set: function (value) {
                if(!this.isEnable){
                    if (value == 0) {
                        this.isBorder = 0;
                    } else {
                        this.isBorder = value;
                    }
                    setTimeout(() =>{
                        this.createBorder();
                        this.createStyle();
                    },20);
                }
            },
            get: function () {
                return this.isBorder;
            }
        });
      
    }
}



// WEBPACK FOOTER //
// ./src/js/div/divUnit/fvPictureObj.js